import { ReactElement, useEffect, useState } from "react";
import { IChartWrapperProps } from "../../types";
import LineChart from "../../../../components/charts/lineChart";
import { ILineChartConfig } from "../../../../components/charts/types";
import { getGenericChartConfig } from "./utils";

const LineChartWrapper = ({ cell, data, parentSize, palette, updatePalette, node, schemas }: IChartWrapperProps): ReactElement => {
  const [ chartConfig, setChartConfig ] = useState<ILineChartConfig | null>(null);

  useEffect(() => {
    if (data) {
      const [ series, xAxis, yAxis ] = getGenericChartConfig(data, cell, node, palette, updatePalette, schemas);

      setChartConfig({
        // width: 300,
        height: parentSize.height,
        xAxis,
        yAxis,
        series,
        showLegend: true,
        pointStyle: {
          radius: 4
        }
      });
    }
  }, [cell, data, parentSize, palette, updatePalette, node, schemas]);

  return (
    <div style={{ ...parentSize }}>
      {chartConfig && <LineChart lineChartConfig={chartConfig}/>}
    </div>
  );
};

export default LineChartWrapper;
